function PageNotFound() {
  return <div>Page not Found</div>;
}

export default PageNotFound;
